import { render, staticRenderFns } from "./TwoFactorCodeInput.vue?vue&type=template&id=638d0c5b&scoped=true"
import script from "./TwoFactorCodeInput.vue?vue&type=script&lang=js"
export * from "./TwoFactorCodeInput.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorCodeInput.vue?vue&type=style&index=0&id=638d0c5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638d0c5b",
  null
  
)

export default component.exports